import { useNavigate } from 'react-router';
import dynamicfunction from '../../utils/dynamicfunction';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteAccountOpeningDraft, generateAccountOtp, getAccountOpeningForm, verifyAccountOtp } from '../../store/actions/accountOpeningAction';
import { getContentKeyAccToLang, setToken } from '../../utils/utils';
import { setApplicationId, setLastLogin } from '../../store/slices/contentSlice';
import dayjs from 'dayjs';
import { setNafathVerified } from '../../store/slices/accountOpeningSlice';

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const { TextWeight, isArabic } = dynamicfunction();

  const configurationSettingsData = useSelector((state) => state.content?.configurationSettingsData);
  const { sendOtpLoading, verifyOtpLoading } = useSelector((state) => state.accountOpening)
  const authContent = useSelector((state) => state.content?.authContent);
  const { applicationId } = useSelector((state) => state.content);
  const accountOpeningData = useSelector((state) => state.content?.accountOpeningData);
  const is_nafath_verified = useSelector((state) => state.accountOpening?.is_nafath_verified);

  const [timerKey, setTimerKey] = useState(0);
  const [timer, setTimer] = useState((configurationSettingsData?.otpTimer ?? 5) * 60);
  const [isDisabled, setIsDisabled] = useState(false);
  const [otp, setOtp] = useState("")
  const [resumeModal, setResumeModal] = useState(false)
  const [isResendCode, setIsResendCode] = useState(false)

  useEffect(() => {
    setTimer((configurationSettingsData?.otpTimer ?? 5) * 60)
  }, [sendOtpLoading])

  const getContentKey = (key) => {
    return getContentKeyAccToLang(authContent?.web_otp_verification?.data?.attributes, key, isArabic);
  };

  const verifyOtp = () => {
    const apiData = {
      otp: otp,
      corpClientId: accountOpeningData?.corpClientId,
      languageId: isArabic ? 2 : 1
    }
    dispatch(verifyAccountOtp(apiData, (res) => {
      const token = res?.result?.token?.accessToken
      setToken(token)
      dispatch(setLastLogin(dayjs()));
      dispatch(setNafathVerified(res?.result?.isNafathVerified ?? false))
      dispatch(setApplicationId(res?.result?.corpClientApplicationId))
      const isExist = accountOpeningData?.hasUnfinishedDraftApplication
      if (isExist) {
        setResumeModal(true)
      } else {
        if (res?.result?.isNafathVerified) {
          navigate("/corporate-form?step=1", { replace: true })
        } else {
          navigate("/nafath-verification", { replace: true })
        }
      }
    },
    ))
  }

  useEffect(() => {
    otp?.length === 4 && verifyOtp()
  }, [otp])

  const resendOtp = () => {
    const otpData = {
      corpClientId: accountOpeningData?.corpClientId,
      languageId: isArabic ? 2 : 1
    }
    dispatch(generateAccountOtp(otpData, () => {
      setIsResendCode(false);
      setTimerKey((prevKey) => prevKey + 1);
    }))
  }

  const handleDiscard = () => {
    const api_data = {
      corpClientApplicationId: applicationId,
      languageId: isArabic ? 2 : 1
    }
    dispatch(deleteAccountOpeningDraft(api_data, (res) => {
      dispatch(setApplicationId(res?.result?.corpClientApplicationId))
      dispatch(getAccountOpeningForm(isArabic ? 2 : 1, () => {
        setResumeModal(false);
        navigate("/corporate-form?step=1")
      }))
    }))
  }

  const handleResume = () => {
    if (is_nafath_verified) {
      navigate("/corporate-form?step=1", { replace: true })
    } else {
      navigate("/nafath-verification", { replace: true })
    }
  }

  return {
    TextWeight,
    navigate,
    timerKey,
    setTimerKey,
    timer,
    isDisabled,
    setIsDisabled,
    verifyOtp,
    otp,
    setOtp,
    resumeModal,
    setResumeModal,
    resendOtp,
    sendOtpLoading,
    getContentKey,
    isResendCode,
    setIsResendCode,
    verifyOtpLoading,
    handleDiscard,
    handleResume
  };
};
